import React, { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import {
  MenuItem,
  Button,
  Avatar,
  Menu,
  Typography,
  IconButton,
  Toolbar,
  Box,
  AppBar,
  ClickAwayListener,
} from "@mui/material";
import { useAuth } from "../../../Hooks/useAuth";
import { useNavigate, Link } from "react-router-dom";
import AccountMenu from "./AccountMenu";
import AdminMenu from "./AdminMenu";
import SystemSettingsMenu from "./SystemSettingsMenu";
import ClientInvoicesMenu from "./ClientInvoicesMenu";
import WorkflowMenu from "./WorkflowMenu";
import DocumentsMenu from "./DocumentsMenu";

export function Navbar({ pages }) {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const { logout, authData, isAdmin } = useAuth();
  const navigate = useNavigate();

  const settings = [];
  if (isAdmin) {
    settings.push({ title: "Profil", route: `/users/${authData.appUserID}` });
  } else {
    settings.push({ title: "Byt lösenord", route: `/changepassword` });
  }

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <>
      {authData.userType === "admin" && (
        <AppBar
          position="relative"
          sx={{
            paddingLeft: "1rem",
            paddingRight: "1rem",
            background:
              process.env.REACT_APP_ENV !== "PRODUCTION" ? "black" : "primary",
          }}
        >
          <Toolbar
            disableGutters
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <a
              href="/dashboard"
              style={{ cursor: "pointer", marginRight: "30px" }}
            >
              <img
                src="/Swesum_logo_white-1024x232.png"
                width="150px"
                alt="Swesum Logo"
              />
            </a>

            <Box
              sx={{
                display: { xs: "flex", md: "none" },
              }}
            >
              <IconButton
                size="large"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                {pages.map((page) => (
                  <MenuItem
                    key={page.title}
                    onClick={handleCloseNavMenu}
                    component={Link}
                    to={page.route}
                  >
                    <Typography textAlign="center">{page.title}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>

            <Box
              sx={{
                display: { xs: "none", md: "flex" },
              }}
            >
              {pages.map((page) => (
                <Button
                  key={page.title}
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: "white", display: "block" }}
                  component={Link}
                  to={page.route}
                >
                  {page.title}
                </Button>
              ))}

              <DocumentsMenu />
              <AccountMenu />
              <ClientInvoicesMenu />

              <Button
                key="FILER"
                onClick={handleCloseNavMenu}
                component={Link}
                sx={{ color: "white", my: 2 }}
                to="files"
              >
                {"FILER"}
              </Button>

              <SystemSettingsMenu>System</SystemSettingsMenu>
              {process.env.REACT_APP_ENV !== "PRODUCTION" ? (
                <WorkflowMenu />
              ) : null}
              <AdminMenu />
              <Button
                onClick={handleCloseNavMenu}
                component={Link}
                sx={{ color: "white", my: 2 }}
                to="reports"
              >
                INTERNA RAPPORTER
              </Button>
            </Box>

            <Box sx={{ position: "absolute", right: 0 }}>
              <ClickAwayListener onClickAway={handleCloseUserMenu}>
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
                </IconButton>
              </ClickAwayListener>

              <Menu
                sx={{ mt: "45px" }}
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem
                    key={setting.title}
                    onClick={handleCloseUserMenu}
                    component={Link}
                    to={setting.route}
                  >
                    <Typography textAlign="center">{setting.title}</Typography>
                  </MenuItem>
                ))}
                <MenuItem
                  key={"logout"}
                  onClick={() =>
                    logout(() => navigate("/login", { replace: true }))
                  }
                >
                  <Typography textAlign="center">Logga ut</Typography>
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </AppBar>
      )}

      {authData.userType === "client" && (
        <AppBar position="static">
          <Toolbar>
            <a
              href="/mypages"
              style={{ cursor: "pointer", marginRight: "30px" }}
            >
              <img
                src="/Swesum_logo_white-1024x232.png"
                width="150px"
                alt="Swesum Logo"
              />
            </a>
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1 }}
            ></Typography>
            <Box sx={{ flexGrow: 0 }}>
              <ClickAwayListener onClickAway={handleCloseUserMenu}>
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
                </IconButton>
              </ClickAwayListener>

              <Menu
                sx={{ mt: "45px" }}
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem
                    key={setting.title}
                    onClick={handleCloseUserMenu}
                    component={Link}
                    to={setting.route}
                  >
                    <Typography textAlign="center">{setting.title}</Typography>
                  </MenuItem>
                ))}
                <MenuItem
                  key={"logout"}
                  onClick={() =>
                    logout(() => navigate("/login", { replace: true }))
                  }
                >
                  <Typography textAlign="center">Logga ut</Typography>
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </AppBar>
      )}
    </>
  );
}
